import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_7405",
	"data-name": "Group 7405",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_3872",
				"data-name": "Rectangle 3872",
				width: 16,
				height: 16
			})
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_7404",
			"data-name": "Group 7404",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_19303",
				"data-name": "Path 19303",
				d: "M12.444,4.444,11.191,5.7l1.4,1.413H5.333V8.889H12.6l-1.4,1.4,1.253,1.262L16,8ZM1.778,1.778H8V0H1.778A1.783,1.783,0,0,0,0,1.778V14.222A1.783,1.783,0,0,0,1.778,16H8V14.222H1.778Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSignout);
export default ForwardRef;
